// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Apwrv","text":"style_text__LSCBY","description":"style_description__kE+Cu","actions":"style_actions__DDDRT","actions_btn":"style_actions_btn__+qOA9"};